export default "__VITE_ASSET__DGl2qiws__"